import type { FC } from 'react';
import React from 'react';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { IconButton, Stack } from '@mui/material';

import { styles } from './index.styles';

export const MODAL_CLOSE_BUTTON_TEST_ID = 'close-modal-button';

export interface ModalCloseHeaderProps {
  onClose: (x?: boolean) => void;
}

const ModalCloseHeader: FC<ModalCloseHeaderProps> = ({ onClose }) => (
  <Stack>
    <IconButton
      sx={styles.closeIcon}
      onClick={() => onClose(true)}
      data-test-id={MODAL_CLOSE_BUTTON_TEST_ID}
    >
      <CloseRounded />
    </IconButton>
  </Stack>
);

export default ModalCloseHeader;
